import {
  CCardBody,
  CCardHeader,
  CCol,
  CLabel,
  CRow,
  CSpinner,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { apiCallResponse, downloadUrl } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import { DetailLableBind, DetailSectionBind } from "../common/Common";

export const DetailDocumentBind = (props) => {
  const hrefSet = `${downloadUrl}/Documents/UserDocument/${props.userId}/${props.path}`;
  console.log("DetailDocumentBind hrefSet : ", props.lable, hrefSet);
  return (
    <>
      {props.islarge === true ? (
        <CCol xxl={6} xl={6} md={6} sm={12} xs={12} className={"mt-2"}>
          <CLabel className={"userDocument"}> {props.lable} </CLabel>
          {props.path && (
            <a className="ml-2" target="_blank" href={hrefSet} rel="noreferrer">
              View
            </a>
          )}
        </CCol>
      ) : (
        <CCol xxl={3} xl={4} md={6} sm={6} xs={12} className={"mt-2"}>
          <CLabel className={"userDocument"}> {props.lable} </CLabel>
          {props.path && (
            <a className="ml-2" target="_blank" href={hrefSet} rel="noreferrer">
              View
            </a>
          )}
        </CCol>
      )}
    </>
  );
};
export const BidderProfile = () => {
  const { authenticated } = Auth();
  const [usersData, setuserData] = useState();
  const [userDocs, setUserDocs] = useState();
  const [loading, setloading] = useState(false);

  useEffect(() => {
    setloading(true);
    getLotDocument(authenticated.userId);
    getUserDocument(authenticated.userId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);
  const getLotDocument = async (userid) => {
    if (authenticated) {
      setloading(true);
      console.log("userId ", userid);
      await apiCallResponse(`Bidder/getBidder?userId=${userid}`).then((res) => {
        if (res.success) {
          setuserData(res.data);
        }
        setloading(false);
      });
    }
  };

  const getUserDocument = async (userid) => {
    if (authenticated) {
      await apiCallResponse(`User/GetUserDocument?userid=${userid}`).then(
        (res) => {
          if (res.success) setUserDocs(res.data);
        }
      );
    }
  };

  return (
    <div>
      {loading ? (
        <CRow>
          <CCol xs="12">
            <CCardHeader>
              <h2>Profile Details</h2>
            </CCardHeader>
            <CCardBody>
              <CSpinner
                className="spinner-grow col-6 offset-6 mt-6"
                color="success"
              />
            </CCardBody>
          </CCol>
        </CRow>
      ) : (
        <>
          {usersData && (
            <>
              <DetailSectionBind
                className={"mb-2"}
                header={"Profile Details"}
                body={
                  <>
                    <DetailLableBind
                      lable="Email Address"
                      value={usersData?.emailId && usersData?.emailId}
                    />
                    <DetailLableBind
                      lable="Alter Email"
                      value={
                        usersData?.alternateEmail && usersData?.alternateEmail
                      }
                    />
                    <DetailLableBind
                      lable="Goods and Services"
                      value={usersData?.gst && usersData?.gst}
                    />
                    <DetailLableBind
                      lable="Propritor Name"
                      //value={usersData?.directorName && usersData?.directorName}
                      value={usersData?.username && usersData?.username}
                    />
                    <DetailLableBind
                      lable="Father Name"
                      value={usersData?.lastName && usersData?.lastName}
                    />
                    <DetailLableBind
                      lable="House No"
                      value={usersData?.houseNo && usersData?.houseNo}
                    />
                    <DetailLableBind
                      lable="Street Location"
                      value={usersData?.streetName && usersData?.streetName}
                    />
                    <DetailLableBind
                      lable="Area Landmark"
                      value={usersData?.area && usersData?.area}
                    />

                    <DetailLableBind
                      lable="Company City"
                      value={usersData?.city && usersData?.city}
                    />

                    <DetailLableBind
                      lable="District Union"
                      value={usersData?.disctrict && usersData?.disctrict}
                    />
                    <DetailLableBind
                      lable="State Name"
                      value={usersData?.state && usersData?.state}
                    />
                    <DetailLableBind
                      lable="Pincode"
                      value={usersData?.pincode && usersData?.pincode}
                    />

                    <DetailLableBind
                      lable="Contact No 1"
                      value={usersData?.contact1 && usersData?.contact1}
                    />
                    <DetailLableBind
                      lable="Contact Number 2"
                      value={usersData?.contact2 && usersData?.contact2}
                    />
                    <DetailLableBind
                      lable="Contact Number 3 "
                      value={usersData?.contact3 && usersData?.contact3}
                    />
                    <DetailLableBind
                      lable="Fax Number"
                      value={usersData?.fax && usersData?.fax}
                    />
                  </>
                }
              />

              <DetailSectionBind
                header={"Company Details"}
                className={"mt-2 mb-2"}
                body={
                  <>
                    <DetailLableBind
                      lable="Company Name"
                      value={usersData?.companyName && usersData?.companyName}
                    />
                    <DetailLableBind
                      lable="Tender Category"
                      value={usersData?.categoryName && usersData?.categoryName}
                    />
                    <DetailLableBind
                      lable="Pan Card"
                      value={usersData?.pan && usersData?.pan}
                    />
                    <DetailLableBind
                      lable="Registration Details"
                      value={
                        usersData?.registrationDetails &&
                        usersData?.registrationDetails
                      }
                    />
                    <DetailLableBind
                      lable="Name of Forest Division Where Tenderer Registered"
                      value={
                        usersData?.registeredDistrict &&
                        usersData?.registeredDistrict
                      }
                    />
                    <DetailLableBind
                      lable="Status of Tenderer"
                      value={usersData?.companyType && usersData?.companyType}
                    />
                  </>
                }
              />
              <DetailSectionBind
                header={"Bidder Capacity"}
                className={"mt-2 mb-2"}
                body={
                  <>
                    <DetailLableBind
                      lable="Tenderers Bank Details"
                      value={
                        usersData?.bankAccountType && usersData?.bankAccountType
                      }
                    />
                    <DetailLableBind
                      lable="Accounter Name"
                      value={
                        usersData?.accountNumber && usersData?.accountNumber
                      }
                    />
                    <DetailLableBind
                      lable="Bank Branch"
                      value={usersData?.bankBranch && usersData?.bankBranch}
                    />
                    <DetailLableBind
                      lable="IFS Code"
                      value={usersData?.ifscCode && usersData?.ifscCode}
                    />
                    <DetailLableBind
                      lable="Emd Amount"
                      value={usersData?.emdAmount && usersData?.emdAmount}
                    />
                    <DetailLableBind
                      lable="Purchase Capacity"
                      value={
                        usersData?.purchaseCapacity &&
                        usersData?.purchaseCapacity
                      }
                    />
                    <DetailLableBind
                      lable="Bidding Capacity"
                      value={
                        usersData?.biddingCapacity && usersData?.biddingCapacity
                      }
                    />
                  </>
                }
              />
              <DetailSectionBind
                header={"Company Directors"}
                className={"mt-2 mb-2"}
                body={
                  <>
                    <DetailLableBind
                      lable="Name of the Directors"
                      value={
                        usersData?.directorName1 && usersData?.directorName1
                      }
                    />
                    <DetailLableBind
                      lable="Name of the Directors"
                      value={
                        usersData?.directorName2 && usersData?.directorName2
                      }
                    />
                    <DetailLableBind
                      lable="Name of the Directors"
                      value={
                        usersData?.directorName3 && usersData?.directorName3
                      }
                    />
                    <DetailLableBind
                      lable="Name of the Directors"
                      value={
                        usersData?.directorName4 && usersData?.directorName4
                      }
                    />

                    <DetailLableBind
                      lable="Name of the Directors"
                      value={
                        usersData?.directorName5 && usersData?.directorName5
                      }
                    />

                    <DetailLableBind
                      lable="Name of the Directors"
                      value={
                        usersData?.directorName6 && usersData?.directorName6
                      }
                    />
                    <DetailLableBind
                      lable="Name of the Directors"
                      value={
                        usersData?.directorName7 && usersData?.directorName7
                      }
                    />

                    <DetailLableBind
                      lable="Name of the Directors"
                      value={
                        usersData?.directorName8 && usersData?.directorName8
                      }
                    />
                  </>
                }
              />
            </>
          )}
          {userDocs && (
            <>
              <DetailSectionBind
                header={"User Documents"}
                className={"mt-2 mb-2"}
                body={
                  <>
                    <DetailDocumentBind
                      lable="Pan Card : "
                      userId={userDocs?.userId && userDocs?.userId}
                      path={userDocs?.pancardpath && userDocs?.pancardpath}
                    />
                    <DetailDocumentBind
                      lable="Aadhar Card : "
                      userId={userDocs?.userId && userDocs?.userId}
                      path={
                        userDocs?.aadharcardpath && userDocs?.aadharcardpath
                      }
                    />
                    <DetailDocumentBind
                      lable="ITR1 : "
                      userId={userDocs?.userId && userDocs?.userId}
                      path={userDocs?.itr1path && userDocs?.itr1path}
                    />
                    <DetailDocumentBind
                      lable="ITR2 : "
                      userId={userDocs?.userId && userDocs?.userId}
                      path={userDocs?.itr2path && userDocs?.itr2path}
                    />
                    <DetailDocumentBind
                      lable="ITR3 : "
                      userId={userDocs?.userId && userDocs?.userId}
                      path={userDocs?.itr3path && userDocs?.itr3path}
                    />
                    <DetailDocumentBind
                      lable="GSTIN Certificate : "
                      userId={userDocs?.userId && userDocs?.userId}
                      path={
                        userDocs?.gstincertificatepath &&
                        userDocs?.gstincertificatepath
                      }
                    />
                    <DetailDocumentBind
                      lable="DFO Registration Certificate : "
                      userId={userDocs?.userId && userDocs?.userId}
                      path={
                        userDocs?.dforegistrationcertificatepath &&
                        userDocs?.dforegistrationcertificatepath
                      }
                    />
                    <DetailDocumentBind
                      lable="Scanned copy of Partnership Firm : "
                      userId={userDocs?.userId && userDocs?.userId}
                      path={
                        userDocs?.scannedcopyofpartnershipfirmpath &&
                        userDocs?.scannedcopyofpartnershipfirmpath
                      }
                    />
                    <DetailDocumentBind
                      lable="Scanned copy of Certificate of Company Incorporation of Latest Directors of company, AOA and MOA : "
                      userId={userDocs?.userId && userDocs?.userId}
                      path={userDocs?.moapath && userDocs?.moapath}
                      islarge={true}
                    />
                    <DetailDocumentBind
                      lable="Scanned copy of list of family members in case of H.U.F. : "
                      userId={userDocs?.userId && userDocs?.userId}
                      path={userDocs?.hufpath && userDocs?.hufpath}
                      islarge={true}
                    />
                    <DetailDocumentBind
                      lable="Any other related document : "
                      userId={userDocs?.userId && userDocs?.userId}
                      path={userDocs?.otherdocument && userDocs?.otherdocument}
                    />
                  </>
                }
              />
            </>
          )}
        </>
      )}
    </div>
  );
};
